'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _moment = require('@alicd/next/lib/moment');

var _moment2 = _interopRequireDefault(_moment);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _localeProvider = require('@alicd/next/lib/locale-provider');

var _localeProvider2 = _interopRequireDefault(_localeProvider);

var _lib = require('@alicd/next/lib/_components/@alicd/next-util/lib');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _basicPickTool = require('./module/basic-pick-tool');

var _basicPickTool2 = _interopRequireDefault(_basicPickTool);

var _calendarTable = require('./table/calendar-table');

var _calendarTable2 = _interopRequireDefault(_calendarTable);

var _calendarMixin = require('./calendar-mixin');

var _calendarMixin2 = _interopRequireDefault(_calendarMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Calendar */
var Calendar = function (_Component) {
    (0, _inherits3.default)(Calendar, _Component);

    function Calendar(props, context) {
        (0, _classCallCheck3.default)(this, Calendar);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Calendar.__proto__ || (0, _getPrototypeOf2.default)(Calendar)).call(this, props, context));

        _this.state = {
            base: props.base ? (0, _moment2.default)(props.base) : (0, _moment2.default)(),
            value: props.value ? (0, _moment2.default)(props.value) : (0, _moment2.default)(),
            mode: props.mode
        };
        return _this;
    }

    (0, _createClass3.default)(Calendar, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            if ('base' in newProps) {
                this.setState({
                    base: newProps.base ? (0, _moment2.default)(newProps.base) : (0, _moment2.default)()
                });
            }

            if ('value' in newProps) {
                this.setState({
                    value: newProps.value ? (0, _moment2.default)(newProps.value) : (0, _moment2.default)()
                });
            }

            if ('mode' in newProps) {
                this.setState({
                    mode: newProps.mode
                });
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(needChange, nextState) {
            if (needChange) {
                this.setState(nextState);
            }

            this.props.onChange(nextState);
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                className = _props.className,
                onChange = _props.onChange,
                others = (0, _objectWithoutProperties3.default)(_props, ['className', 'onChange']);
            var type = others.type;

            var prefix = this.context.prefix || others.prefix;
            var state = this.state;

            var calendarCls = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, prefix + 'calendar', true), (0, _defineProperty3.default)(_classNames, prefix + 'calendar-' + type, type), (0, _defineProperty3.default)(_classNames, className, className), _classNames));

            return _react2.default.createElement(
                'div',
                (0, _extends3.default)({}, (0, _lib.pickAttrs)(others), { className: calendarCls, ref: 'calendar' }),
                _react2.default.createElement(
                    'div',
                    { className: prefix + 'calendar-header' },
                    _react2.default.createElement(_basicPickTool2.default, (0, _extends3.default)({}, others, { base: state.base, value: state.value, mode: state.mode, onChange: this.onChange.bind(this, true) }))
                ),
                _react2.default.createElement(
                    'div',
                    { className: prefix + 'calendar-body' },
                    _react2.default.createElement(_calendarTable2.default, (0, _extends3.default)({}, others, { base: state.base, value: state.value, mode: state.mode, onChange: this.onChange.bind(this, false) }))
                )
            );
        }
    }]);
    return Calendar;
}(_react.Component);

Calendar.propTypes = {
    /**
     * 样式品牌前缀
     */
    prefix: _propTypes2.default.string,
    /**
     * 基准日期
     */
    base: _propTypes2.default.any,
    /**
     * 选中的日期值
     */
    value: _propTypes2.default.any,
    /**
     * 面板选择模式
     */
    mode: _propTypes2.default.oneOf(['month', 'year', 'decade']),
    /**
     * 类型
     */
    type: _propTypes2.default.oneOf(['fullscreen', 'card']),
    /**
     * 日期改变时的回调
     * @param {Object} calendarDate 对应 Calendar 返回的自定义日期对象
     */
    onChange: _propTypes2.default.func,
    /**
     * 自定义样式类
     */
    className: _propTypes2.default.string,
    /**
     * 自定义日期渲染函数
     * @param {Object} calendarDate 对应 Calendar 返回的自定义日期对象
     * @returns {Function}
     */
    dateCellRender: _propTypes2.default.func,
    /**
     * 自定义月份渲染函数
     * @param {Object} calendarDate 对应 Calendar 返回的自定义日期对象
     * @returns {Function}
     */
    monthCellRender: _propTypes2.default.func,
    /**
     * 自定义年份渲染函数
     * @param {Object} calendarDate 对应 Calendar 返回的自定义日期对象
     * @returns {Function}
     */
    yearCellRender: _propTypes2.default.func,
    /**
     * 不可选择的日期
     * @param {Object} calendarDate 对应 Calendar 返回的自定义日期对象
     * @returns {Boolean}
     */
    disabledDate: _propTypes2.default.func,
    /**
     * 不可选择的月份
     * @param {Object} calendarDate 对应 Calendar 返回的自定义日期对象
     * @returns {Boolean}
     */
    disabledMonth: _propTypes2.default.func,
    /**
     * 不可选择的年份
     * @param {Object} calendarDate 对应 Calendar 返回的自定义日期对象
     * @returns {Boolean}
     */
    disabledYear: _propTypes2.default.func,
    /**
     * 多语言选择
     */
    language: _propTypes2.default.oneOf(['en-us', 'ar', 'de', 'es', 'fr', 'hi', 'it', 'ja', 'ko', 'pt', 'ru', 'zh-cn', 'zh-hk', 'zh-tw']),
    /**
     * 国际化配置
     */
    locale: _propTypes2.default.object
};
Calendar.defaultProps = {
    prefix: 'next-',
    type: 'fullscreen',
    mode: 'month',
    onChange: function onChange() {}
};
Calendar.contextTypes = {
    prefix: _propTypes2.default.string
};


(0, _calendarMixin2.default)(Calendar);

exports.default = (0, _localeProvider2.default)(Calendar);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-calendar-ex@0.0.4@@alicd/crui-calendar-ex/lib/view/calendar.js
// module id = 623
// module chunks = 0